import IconButton from "@mui/material/IconButton";
import PropTypes from "prop-types";
import React from "react";

import { CloseIcon } from "common/DS/Icons";
import SVGIcon from "common/SVGIcon";

/**
 * Use this component for making our old SVG spritesheet icons look like
 * MUI icon buttons.
 *
 * If you want to use a MUI icon, just use <IconButton><Icon /></IconButton>
 * or use SmallIconButton or LargeIconButton below!
 */
const SVGIconButtonBase = ({ icon, iconProps, ...props }) => (
    <IconButton {...props}>
        <SVGIcon icon={icon} {...iconProps} />
    </IconButton>
);

SVGIconButtonBase.propTypes = {
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    iconProps: PropTypes.shape({}),
};

SVGIconButtonBase.defaultProps = {
    iconProps: {},
};

export const SVGIconButton = React.memo(SVGIconButtonBase);
export const SmallSVGIconButton = (props) => <SVGIconButton size="small" {...props} />;

// For use in modals and dialogs, etc
export const CloseButton = (props) => (
    <IconButton {...props}>
        <CloseIcon />
    </IconButton>
);

const SizeIconButton = ({ size, children, ...props }) => (
    <IconButton size={size} {...props}>
        {React.cloneElement(children, { fontSize: size })}
    </IconButton>
);
SizeIconButton.propTypes = {
    size: PropTypes.oneOf(["small", "medium", "large"]).isRequired,
};

// Default IconButton is medium already
export const SmallIconButton = (props) => <SizeIconButton size="small" {...props} />;
export const LargeIconButton = (props) => <SizeIconButton size="large" {...props} />;
